module.exports = __webpack_public_path__ + "img/step_cright_img01.57eccdf0.png";